import { useEffect, useState } from "react";

import getLocationService from "../services/getLocation.service";

export default function useLocation() {
  const [location, setLocation] = useState<Record<string, any> | null>(null);

  const getLocation = async () => {
    const response = await getLocationService();
    setLocation(response);
  };

  useEffect(() => {
    getLocation();
  }, []);

  return { location };
}
